var api = require("!../../../../../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/postcss-loader/src/index.js??postcss!../../../../../node_modules/sass-loader/dist/cjs.js!./LogoBar.scss");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.id, content, '']];
            }

var options = {};

options.insert = function(styleTag) {
                function findNestedWebComponents(tagName, root = document) {
                  const elements = [];

                  // Check direct children
                  root.querySelectorAll(tagName).forEach((el) => elements.push(el));

                  // Check shadow DOMs
                  root.querySelectorAll('*').forEach((el) => {
                    if (el.shadowRoot) {
                      elements.push(...findNestedWebComponents(tagName, el.shadowRoot));
                    }
                  });

                  return elements;
                }
                if (!window.isApryseWebViewerWebComponent) {
                  document.head.appendChild(styleTag);
                  return;
                }

                let webComponents;
                // First we see if the webcomponent is at the document level
                webComponents = document.getElementsByTagName('apryse-webviewer');
                // If not, we check have to check if it is nested in another webcomponent
                if (!webComponents.length) {
                  webComponents = findNestedWebComponents('apryse-webviewer');
                }
                // Now we append the style tag to each webcomponent
                const clonedStyleTags = [];
                for (let i = 0; i < webComponents.length; i++) {
                  const webComponent = webComponents[i];
                  if (i === 0) {
                    webComponent.shadowRoot.appendChild(styleTag);
                    styleTag.onload = function() {
                      if (clonedStyleTags.length > 0) {
                        clonedStyleTags.forEach((styleNode) => {
                          // eslint-disable-next-line no-unsanitized/property
                          styleNode.innerHTML = styleTag.innerHTML;
                        });
                      }
                    };
                  } else {
                    const styleNode = styleTag.cloneNode(true);
                    webComponent.shadowRoot.appendChild(styleNode);
                    clonedStyleTags.push(styleNode);
                  }
                }
              };
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};